import { RouteObject } from "react-router-dom";
import Notification from "../../Pages/Notifications/Notifications";
import View from "../../Pages/Notifications/View";

export const NOTIFICATIONS = "/notifications";
export const NOTIFICATIONS_VIEW = "/notifications/:id/view";

const Notifications: RouteObject[] = [
  { path: NOTIFICATIONS, element: <Notification /> },
  { path: NOTIFICATIONS_VIEW, element: <View /> },
];

export default Notifications;
